import { PackageUnitConverter } from '@/js/App/PackageUnitConverter'
import { Control } from '@peckadesign/pd-naja/dist/types'

class PackageUnitConverterControl implements Control {
	public initialize(context: Element | Document): void {
		context.querySelectorAll<HTMLElement>(PackageUnitConverter.selector).forEach((element) => {
			new PackageUnitConverter(element)
		})
	}
}

export default new PackageUnitConverterControl()
